import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AppError } from '../models/app-error.model';
import { CORRELATION_HEADER } from './correlation-id.interceptor';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: unknown) => {
      const correlationId = req.headers.get(CORRELATION_HEADER) ?? undefined;

      if (error instanceof HttpErrorResponse) {
        const body = error.error as { message?: string; code?: string | number } | null;
        const appError: AppError = {
          correlationId,
          code: body?.code != null ? String(body.code) : String(error.status),
          message: body?.message || error.message || 'Unexpected error',
          retryable: error.status >= 500 || error.status === 0,
        };
        return throwError(() => appError);
      }

      const appError: AppError = {
        correlationId,
        message: 'Unexpected error',
        retryable: true,
      };
      return throwError(() => appError);
    })
  );
};
